import React, { useState } from "react";
import {
  CellTmpl,
  reactFormatter,
} from "../../../common/Table";
import VendorCategoryDetails from "./VendorCategoryDetails";
import { useGetVendorCategories } from "../../../../backend/masters";
import { GetMastersBreadcrumb } from "../Master.constants";
import {
  useExportVendorCategories,
} from "../../../../backend/exports";
import BaseList from "../../../common/BaseList";
import AddEditVendorCategory from "./AddEditVendorCategory";
import { VendorCategorySchema } from "../../../../models/vendor_category";

function VendorCategories() {
  const [breadcrumb] = useState(GetMastersBreadcrumb("Vendor Categories"));
  
  const columns = [
    {
      title: "Category",
      field: "name",
      formatter: reactFormatter(<CellTmpl />),
    }
  ];

  return (
    <BaseList
        fetchData={useGetVendorCategories}
        exportData={useExportVendorCategories}
        deleteData={() => {return {deleteRecord: null, deleting: false}}}
        nameAttribute={'name'}
        columns={columns}
        DetailView={VendorCategoryDetails}
        FormView={AddEditVendorCategory}
        modelSchema={VendorCategorySchema}
        initialSort={['name asc']}
        breadcrumb={breadcrumb}
        title="Mastsers - Vendor Categories"
    />
  );
}

export default VendorCategories;
